import React, { useEffect, useState, } from 'react';
import styled from 'styled-components';
import colors from 'theme/colors';
import TimeWarning from './TimeWarning';
import ReceiptForm from './ReceiptForm';
import checkoutApi from 'api/requests/checkout';
import customFieldsApi from 'api/requests/customFields';
import { useCheckout } from 'context/checkout/Checkout';
import Loader from 'components/_UI/Loader';
import { useCollapse } from 'context/general/Collapse';
import Button from 'components/_UI/Button';
import regex from 'helpers/regex';
import Modal from 'components/_UI/Modal';
import { Row } from 'styled/alignment/Row';
import { CheckCircle } from 'lucide-react';
import Text from 'components/_UI/Text';
import buttonText from 'texts/buttons/buttonText';
import routeParams from 'theme/routeParams';
import paths from 'routes/paths';
import { useNavigate, useSearchParams } from 'react-router-dom';
import {
  hasUniqueGuestError,
  uniqueGuestErrorMessage
} from '../commom/paymentFormUtils';
import { trackEvent } from 'scripts/pixels';

export default function FreePaymentForm({ event, tickets }) {
  const { checkout, setCheckout } = useCheckout();
  const { collapse, setCollapse } = useCollapse();
  const [searchParams, setSearchParams] = useSearchParams();
  const navigate = useNavigate();

  const [trigger, setTrigger] = useState(0);
  const [receiptFormData, setReceiptFormData] = useState(null);
  const [loading, setLoading] = useState(null);
  const [time, setTime] = useState(null)
  const [errorRequest, setErrorRequest] = useState('')
  const [checkoutSuccess, setCheckoutSuccess] = useState('')
  const [customFields, setCustomFields] = useState([])

  function onReceiptFormCompleted(receiptForm) {
    setReceiptFormData(receiptForm);
  }

  function handleSubmit() {
    window.trigger = Math.random(Infinity);
    setTrigger((previousTrigger) => previousTrigger + 1)
  }

  async function onSubmit() {
    if (!receiptFormData) {
      return;
    }

    setLoading(true);

    const payload = {
      customer: createCustomerPayload(receiptFormData),
    };

    try {
      const { data } = await checkoutApi.checkoutOrder(payload, checkout?.orderId);

      if (data?.status === 'approved') {
        trackEvent('Purchase');
        setCheckoutSuccess(true);
      }
    } catch (error) {
      if (hasUniqueGuestError(error)) {
        setErrorRequest(uniqueGuestErrorMessage);
      } else {
        setErrorRequest('Ocorreu um erro, verifique os dados informados e tente novamente.')
      }
    } finally {
      setReceiptFormData(false)
      setLoading(false);
    }
  }

  function createCustomerPayload(data) {
    const { firstName, lastName, phone, document, guests } = data;

    if (guests.length) {
      return {
        first_name: firstName,
        last_name: lastName,
        phone,
        document: document.replaceAll(regex.nonDigit, ''),
        guests
      }
    }

    return {
      first_name: firstName,
      last_name: lastName,
      phone,
      document: document.replaceAll(regex.nonDigit, ''),
      guests: []
    }
  }

  function goToWallet() {
    navigate(paths.user.wallet);
    // setCollapse({
    //   ...collapse,
    //   arrowPosition: false,
    //   componentToRender: () => <MainWallet />
    // })
  }

  function goToHome() {
    setSearchParams((prevSearchParams) => {
      const newSearchParams = new URLSearchParams(prevSearchParams);
      newSearchParams.delete(routeParams.payments.checkout)

      return newSearchParams;
    });
    setCollapse({
      ...collapse,
      height: 'min',
      withContent: false,
    })
  }

  async function getCustomFields() {
    if (!event?.slug) {
      return;
    }

    const response = await customFieldsApi.get(event.slug)
    setCustomFields((prev) => {
      return [
        ...prev,
        ...response?.data?.data
      ]
    })
  }

  useEffect(() => {
    onSubmit()
  }, [receiptFormData])

  useEffect(() => {
    getCustomFields()
  }, [])

  return (
    <>
      <FormContent>
        <TimeWarning setTime={setTime} />

        <ReceiptForm
          trigger={trigger}
          tickets={tickets}
          customFields={customFields}
          onReceiptFormCompleted={onReceiptFormCompleted}
          hasDocument={true}
        />

        {
          loading
            ? <Loader />
            : (
              <Button
                marginTop={'35px'}
                marginBottom={'30px'}
                // variant={errorRequest ? 'disabled' : 'featured'}
                onClick={handleSubmit}
              >
                Finalizar compra
              </Button>
            )
        }

        {
          errorRequest && <Text color={colors.danger} paddingLeft={'6px'}>{errorRequest}</Text>
        }

        {
          checkoutSuccess && (
            <Modal isOpen={checkoutSuccess} closeButton={false}>
              <Row fullyCentralized>
                <CheckCircle color={colors.successDark} />
                <Text name='highlight' paddingBottom={0} marginLeft={'5px'} color={colors.successDark}>
                  Compra realizada com sucesso
                </Text>
              </Row>

              <Text marginTop={'10px'}>Você receberá um e-mail em breve com todas as informações sobre o seu pedido, incluindo detalhes do ingresso/produto adquirido e instruções adicionais.</Text>
              <Text marginTop={'10px'}>Agradecemos pela sua compra e esperamos que você aproveite ao máximo sua experiência!</Text>

              <RowButtons>
                <Button
                  variant='light'
                  marginRight={'12px'}
                  onClick={goToHome}

                >
                  {buttonText.close}
                </Button>

                <Button variant='lightBlue' onClick={goToWallet}>
                  {buttonText.seeWallet}
                </Button>
              </RowButtons>
            </Modal>
          )
        }
      </FormContent>
    </>
  );
}

const FormContent = styled.form`
  width: 100%;
  padding: 10px 30px;
  background-color: ${colors.neutralLight};
`;

const RowButtons = styled(Row)`
  width: 100%;
  margin-top: 20px;

  & > button {
    box-shadow: unset;
  }
`;
